
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { Menu, X } from "lucide-react";

export function Header() {
  const { user, signOut, isAdmin } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <>
      <header className="w-full bg-gradient-to-r from-green-600 to-emerald-700 text-white shadow-md">
        <div className="container mx-auto px-4 py-4">
          <div className="flex justify-between items-center">
            <Link to="/" className="flex items-center gap-2">
              <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold tracking-tight">Bins and Things</h1>
            </Link>
            
            {/* Desktop Navigation */}
            <nav className="hidden lg:flex space-x-6">
              <Link to="/" className="hover:text-green-200 transition-colors">Home</Link>
              <Link to="/pricing" className="hover:text-green-200 transition-colors">Pricing</Link>
              <Link to="/why-bin-washing" className="hover:text-green-200 transition-colors">Why Bin Washing</Link>
              <Link to="/gutter-cleaning" className="hover:text-green-200 transition-colors">Gutter Cleaning</Link>
              <Link to="/about-us" className="hover:text-green-200 transition-colors">About Us</Link>
              <Link to="/contact" className="hover:text-green-200 transition-colors">Contact Us</Link>
              
              {isAdmin && (
                <>
                  <Link to="/dashboard" className="hover:text-green-200 transition-colors text-yellow-200">Admin</Link>
                  <button 
                    onClick={() => signOut()} 
                    className="hover:text-green-200 transition-colors text-yellow-200"
                  >
                    Sign Out
                  </button>
                </>
              )}
            </nav>
            
            {/* Mobile Menu Button */}
            <div className="lg:hidden flex items-center gap-2">
              {isAdmin && (
                <Button variant="outline" size="sm" className="bg-blue-600 hover:bg-blue-700 text-white border-blue-600 hover:border-blue-700" onClick={() => signOut()}>
                  Admin Sign Out
                </Button>
              )}
              
              <button
                onClick={toggleMobileMenu}
                className="p-2 hover:bg-white/10 rounded-md transition-colors"
              >
                {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
              </button>
            </div>
          </div>
          
          {/* Mobile Navigation */}
          {mobileMenuOpen && (
            <nav className="lg:hidden mt-4 pb-4 border-t border-green-500/30 pt-4">
              <div className="flex flex-col space-y-3">
                <Link 
                  to="/" 
                  className="hover:text-green-200 transition-colors py-2"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Home
                </Link>
                <Link 
                  to="/pricing" 
                  className="hover:text-green-200 transition-colors py-2"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Pricing
                </Link>
                <Link 
                  to="/why-bin-washing" 
                  className="hover:text-green-200 transition-colors py-2"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Why Bin Washing
                </Link>
                <Link 
                  to="/gutter-cleaning" 
                  className="hover:text-green-200 transition-colors py-2"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Gutter Cleaning
                </Link>
                <Link 
                  to="/coming-soon" 
                  className="hover:text-green-200 transition-colors py-2"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Power Washing
                </Link>
                <Link 
                  to="/about-us" 
                  className="hover:text-green-200 transition-colors py-2"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  About Us
                </Link>
                <Link 
                  to="/contact" 
                  className="hover:text-green-200 transition-colors py-2"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Contact Us
                </Link>
                
                {isAdmin && (
                  <>
                    <Link 
                      to="/dashboard" 
                      className="hover:text-green-200 transition-colors text-yellow-200 py-2"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      Admin Dashboard
                    </Link>
                    <button 
                      onClick={() => {
                        signOut();
                        setMobileMenuOpen(false);
                      }} 
                      className="hover:text-green-200 transition-colors text-left py-2 text-yellow-200"
                    >
                      Admin Sign Out
                    </button>
                  </>
                )}
              </div>
            </nav>
          )}
        </div>
      </header>
      
      {/* Footer with Privacy Policy link */}
      <div className="bg-green-800 text-white py-2 px-4">
        <div className="container mx-auto flex justify-center gap-6">
          <Link to="/privacy-policy" className="text-sm hover:text-green-200 transition-colors">
            Privacy Policy
          </Link>
          <Link to="/admin" className="text-sm hover:text-green-200 transition-colors opacity-50">
            Admin
          </Link>
        </div>
      </div>
    </>
  );
}
